import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "brs_cookie_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      // localStorage blocked - show anyway
      setVisible(true);
    }
  }, []);

  const set = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: value, t: Date.now() }));
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:bottom-6 md:max-w-2xl z-[60] slide-up"
    >
      <div className="rounded-2xl bg-white border border-black/15 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.3)] p-5 md:p-6">
        <div className="flex flex-col sm:flex-row gap-4 items-start">
          <div className="w-10 h-10 rounded-xl bg-black text-white flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-black/45">
              · Cookies
            </div>
            <div className="mt-1 text-sm md:text-base text-black/80 leading-relaxed">
              Wir verwenden ausschließlich technisch notwendige Cookies, damit die
              Seite reibungslos funktioniert. Keine Tracker, kein Marketing.
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                onClick={() => set("accept")}
                data-testid="cookie-accept"
                className="inline-flex items-center justify-center btn-primary px-5 h-10 rounded-full text-xs font-semibold"
              >
                Akzeptieren
              </button>
              <button
                onClick={() => set("essential")}
                data-testid="cookie-essential"
                className="inline-flex items-center justify-center btn-ghost px-5 h-10 rounded-full text-xs font-semibold"
              >
                Nur notwendige
              </button>
            </div>
          </div>
          <button
            onClick={() => set("dismiss")}
            data-testid="cookie-close"
            aria-label="Schließen"
            className="shrink-0 w-9 h-9 rounded-full hover:bg-black/5 flex items-center justify-center text-black/50 hover:text-black transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
